import { FC } from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";
import {
  headerCellStyles,
  headerRowStyles,
} from "../utils/constants/tableStyles";

interface InternalBillingExplorerTotalTableHeaderProps {
  columnDefs: any[];
  renderHeaderComponent: (col: any, index: number) => React.ReactNode;
}

export const InternalBillingExplorerTotalTableHeader: FC<
  InternalBillingExplorerTotalTableHeaderProps
> = ({ columnDefs, renderHeaderComponent }) => (
  <TableHead>
    <TableRow sx={headerRowStyles}>
      {columnDefs.map((col, index) => (
        <TableCell
          key={index}
          align={index === 0 ? "left" : "right"}
          sx={headerCellStyles(index === 0)}
        >
          {renderHeaderComponent(col, index)}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);
